import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Layout from '../components/Layout';
import '../assets/scss/challenge.scss';
import '../assets/scss/v1plus.scss';

// B. Lesson start: the v1 "N 단어 공부해볼까?" screen, with today's Day and topic instead of a count input
const LessonStart = () => {
  const navigate = useNavigate();
  const [h, setH] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!localStorage.getItem('token')) { navigate('/'); return; }
    axios.get('/api/learn/home').then(res => setH(res.data)).catch(() => setError('정보를 불러오지 못했어요.'));
  }, [navigate]);

  return (
    <Layout header={{ Backbtn: true, link: '/Main' }} containName='start v1-keep'>
      {error ? <p className="v1-sub">{error}</p> : !h ? <p className="v1-sub">불러오는 중...</p> : (
        <>
          <strong className="start-text" style={{ fontSize: 22 }}>
            DAY {h.day}<br />{h.topic ? `${h.topic} 영어 해볼까?` : '오늘도 공부해볼까?'}
          </strong>
          <div className="v1-chips">
            <span>새 단어 10</span><span>오늘의 표현 3</span>{h.due > 0 && <span>복습 {h.due}</span>}
          </div>
          <p className="v1-sub">{h.todayDone ? '오늘 레슨을 이미 했어요. 한 번 더 해도 좋아요!' : '약 6분 걸려요'}</p>
          <Link to="/Study/Lesson" className="btn btn-white">START</Link>
          <Link to="/Study/Free" className="v1-link-w">원하는 개수만큼 자유 학습</Link>
        </>
      )}
    </Layout>
  );
};

export default LessonStart;
